export default __webpack_public_path__ + "ebc00bddd7f0455c7bf2ee555a399b77.svg";